import { getRejectedApplications } from './states';

export const services = {
  getRejectedApplications,
};
